module.exports = __webpack_public_path__ + "fonts/ZenOldMincho-Regular.424cf5f0.ttf";